export default "/assets/images/accessory-img-01.2dd4d0b66cb5b42f.jpg";